import { AxiosError } from "axios";
import { useState } from "react";

import {
  QUOTE_CHANNEL_ONLINE,
  QUOTE_JOURNEY_TYPE,
} from "@/config/app-constant";
import { PRODUCT_DOMAIN } from "@/constants";
import axioInstance from "@/libs/axios";
import { useAppDispatch, useAppSelector } from "@/store/hook";
import { updateQuote } from "@/store/slices/quote/quote.slice";
import { RootState } from "@/store/store";
import { ApiErrorProps } from "@/types/ApiErrorType";
import { QuoteData } from "@/types/quote/quote-data";
import { apiErrorMappings } from "@/utils/errors/api-error-map";

interface ErrorResponse {
  code?: number;
  errors?: {
    code: number;
    message: string;
  }[];
}

const useMTAConsentHandler = () => {
  const { version, referenceId, attributes } = useAppSelector(
    (state: RootState) => state.quote
  );
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [createMTAError, setCreateMTAError] = useState<null | ApiErrorProps>(
    null
  );
  const [data, setData] = useState<null | QuoteData>(null);

  const url = `${process.env.NEXT_PUBLIC_BASE_URL}/quote/${referenceId}/updateMtaMedicalConsent`;

  const updateConsent = async (consent: boolean) => {
    const payload = {
      data: {
        type: QUOTE_JOURNEY_TYPE,
        channel: QUOTE_CHANNEL_ONLINE,
        version,
        attributes: {
          domain: PRODUCT_DOMAIN,
          mtaMedicalConsent: {
            isTravellingBeforeRenewal: consent,
          },
        },
      },
    };

    try {
      setIsLoading(true);
      setCreateMTAError(null);
      const response = await axioInstance.patch(url, payload);

      setIsLoading(false);
      if (response.data.code === 200) {
        const quoteData = {
          ...response.data.data,
          attributes: {
            ...response.data.data.attributes,
            mtaMedicalConsent: {
              ...response.data.data.attributes.mtaMedicalConsent,
              currentPolicyRemainingDays:
                attributes?.mtaMedicalConsent?.currentPolicyRemainingDays,
            },
          },
        };
        dispatch(updateQuote(quoteData));
        setData(response.data.data);
      }
    } catch (err) {
      setIsLoading(false);
      const axiosErr = err as AxiosError<ErrorResponse>;
      const errorObject = await apiErrorMappings(axiosErr);
      setCreateMTAError(errorObject);
    }
  };

  return {
    isLoading,
    createMTAError,
    data,
    updateConsent,
  };
};

export default useMTAConsentHandler;
